// Auth schemas (architecture.md §10). Signup is two-step: create account → verify a 6-digit
// email code before first login. No self-service password reset.
import { z } from 'zod';
import { email, username } from './common.js';

export const signupSchema = z.object({
  name: z.string().trim().min(1).max(120),
  username,
  email,
  password: z.string().min(8).max(200),
});

// Verify the 6-digit signup code emailed to the user.
export const verifyOtpSchema = z.object({
  email,
  code: z.string().trim().regex(/^\d{6}$/, 'Enter the 6-digit code'),
});

// Re-send the signup code.
export const resendOtpSchema = z.object({
  email,
});

export const loginSchema = z.object({
  email,
  password: z.string().min(1).max(200),
});

// Admin sets a user's password (no self-service reset in the MVP).
export const adminSetPasswordSchema = z.object({
  password: z.string().min(8).max(200),
});
